import { Meta } from '@/components/common';
import { Container } from '@/components/layout';
import { ActionLogTable } from '@/components/features/audit/ActionLogTable';

export function AuditPage() {
  return (
    <>
      <Meta title="Action log" />

      <Container className="py-8 space-y-6">
        <p className="text-[12.5px] text-muted-foreground">
          Every administrative action, who took it and against what, retained 400 days.
        </p>

        <ActionLogTable />
      </Container>
    </>
  );
}
